import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56190356"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "test-instructions-StepSix-component" }
const _hoisted_2 = { class: "step-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-subtitle" }, " Insira corretamente todos os dados da pessoa que fez o autoteste, para que eles apareçam no cartão de resultado. ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "terms-and-law pt-2" }, " Seguimos a Lei nº 14.289/2022 e a Lei 13.709/2018 quanto ao sigilo e segurança das informações que você está disponibilizando nesta jornada. ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_alert_box = _resolveComponent("alert-box")!
  const _component_base_input = _resolveComponent("base-input")!
  const _component_floating_card = _resolveComponent("floating-card")!
  const _component_no_identification_modal = _resolveComponent("no-identification-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_floating_card, {
      ref: "base-modal",
      stepNumber: "6",
      stepTitle: this.StepContent.title,
      nextButtonActive: "",
      btnNextLabel: 
        _ctx.registerTestStore.resultTest === 'positive'
          ? 'Gerar cartão de resultado'
          : 'Continuar'
      ,
      onNextStep: _cache[4] || (_cache[4] = ($event: any) => (
        _ctx.validRequiredFields
          ? this.$emit('nextStep')
          : this.$refs['no-identification-modal'].toggleModal(true)
      )),
      onPreviousStep: _cache[5] || (_cache[5] = ($event: any) => (this.$emit('previousStep')))
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_alert_box, {
            class: "mt-8 mb-24",
            info: "",
            stepContent: _ctx.StepContent
          }, null, 8, ["stepContent"]),
          _createVNode(_component_base_input, {
            class: "mb-2 hiv-field",
            type: "text",
            ref: "form-name",
            label: "1. Informe seu nome completo",
            placeholder: "Nome e sobrenome",
            validatorType: _ctx.nameFieldValidations,
            modelValue: _ctx.patient.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.patient.name) = $event)),
            required: _ctx.validRequiredFields,
            removeMessages: _ctx.removeMessages
          }, null, 8, ["validatorType", "modelValue", "required", "removeMessages"]),
          _createVNode(_component_base_input, {
            class: "mb-2 hiv-field",
            type: "text",
            ref: "form-document",
            label: "2. Insira seu CPF",
            inputmode: "numeric",
            placeholder: "Dígitos do CPF",
            validatorType: _ctx.cpfFieldValidations,
            mask: "###.###.###-##",
            modelValue: _ctx.patient.document,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.patient.document) = $event)),
            required: _ctx.validRequiredFields,
            removeMessages: _ctx.removeMessages
          }, null, 8, ["validatorType", "modelValue", "required", "removeMessages"]),
          _createVNode(_component_base_input, {
            class: "mb-2 hiv-field",
            type: "text",
            ref: "form-email",
            label: "3. Informe seu e-mail",
            modelValue: _ctx.patient.email,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.patient.email) = $event)),
            onKeyup: _cache[3] || (_cache[3] = ($event: any) => (_ctx.patient.email = _ctx.patient.email.toLowerCase())),
            placeholder: "exemplo@exemplo.com.br",
            autocapitalize: "off",
            validatorType: _ctx.emailFieldValidations,
            required: _ctx.validRequiredFields,
            removeMessages: _ctx.removeMessages
          }, null, 8, ["modelValue", "validatorType", "required", "removeMessages"]),
          _hoisted_4
        ])
      ]),
      _: 1
    }, 8, ["stepTitle", "btnNextLabel"]),
    _createVNode(_component_no_identification_modal, {
      ref: "no-identification-modal",
      onNextStep: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('nextStep')))
    }, null, 512)
  ]))
}